import { AddRounded } from "@mui/icons-material";

export const add = (props) => {
  return <AddRounded {...props} />;
};
